import { Separator } from '@/components/ui/separator'
import { useCategoryDetail } from './context'
import { formatAmount } from '@/lib/utils'
import { subcategoryShade } from './subcategory-color'

type Subcategory = {
  name: string
  amount: number
  count: number
}

type Props = {
  subcategories: Subcategory[]
}

export function CategorySubcategorySection({ subcategories }: Props) {
  const { categoryColor, categoryAmount } = useCategoryDetail()

  // Single subcategory is uninformative (always 100%)
  if (subcategories.length <= 1) return null

  const total = subcategories.length

  return (
    <>
      <Separator />
      <div className="space-y-3">
        <h3 className="text-sm font-medium text-muted-foreground">内訳</h3>

        {/* Stacked bar */}
        <div className="flex h-2 w-full overflow-hidden rounded-full bg-muted">
          {subcategories.map((sub, i) => {
            const width = categoryAmount > 0 ? (sub.amount / categoryAmount) * 100 : 0
            const opacity = subcategoryShade(i, total)
            return (
              <div
                key={sub.name}
                style={{
                  width: `${width}%`,
                  backgroundColor: categoryColor,
                  opacity,
                }}
              />
            )
          })}
        </div>

        {/* Legend */}
        <div className="space-y-1.5">
          {subcategories.map((sub, i) => {
            const percentage =
              categoryAmount > 0 ? Math.round((sub.amount / categoryAmount) * 100) : 0
            const opacity = subcategoryShade(i, total)
            return (
              <div key={sub.name} className="flex items-center gap-2 text-sm">
                <span
                  className="h-2 w-2 shrink-0 rounded-full"
                  style={{ backgroundColor: categoryColor, opacity }}
                />
                <span className="flex-1 min-w-0 truncate">{sub.name}</span>
                <span className="shrink-0 tabular-nums">{formatAmount(sub.amount)}</span>
                <span className="shrink-0 w-10 text-right text-xs text-muted-foreground tabular-nums">
                  {percentage}%
                </span>
              </div>
            )
          })}
        </div>
      </div>
    </>
  )
}
